import { useQuery } from "@apollo/client";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Button, Skeleton, Stack, Typography } from "@mui/material";
import { DashboardTile } from "components/Dashboard/DashboardTile";
import { useTenant } from "hooks/useTenant";
import pluralize from "pluralize";
import { Link as RouterLink } from "react-router-dom";

import { FACILITY_WASTE_CONTAINERS_COUNT_QUERY } from "../../Containers/api";
import { useWasteFacilityState } from "./WasteFacilityContext";

/**
 * Containers summary for the waste facility dashboard: the active container
 * count and a link to the facility-scoped container list. On-site totals
 * arrive with the accumulation limit engine.
 */
export const WasteContainersTile = () => {
  const { tenantId } = useTenant();
  const { effectiveWasteFacilityId } = useWasteFacilityState();

  const { data, loading } = useQuery(FACILITY_WASTE_CONTAINERS_COUNT_QUERY, {
    variables: { facilityId: effectiveWasteFacilityId },
    skip: !effectiveWasteFacilityId,
  });
  const count = data?.facility?.wasteContainers?.count;

  return (
    <DashboardTile size={{ sm: 12, md: 5 }}>
      <DashboardTile.Header title="Containers" />
      <DashboardTile.ContentArea>
        <Stack spacing={2} alignItems="flex-start">
          {loading && count == null ? (
            <Skeleton variant="text" width={180} height={48} />
          ) : (
            <Stack direction="row" spacing={1} alignItems="baseline">
              <Typography variant="h4">{count ?? 0}</Typography>
              <Typography variant="body1" color="text.secondary">
                active {pluralize("container", count ?? 0)}
              </Typography>
            </Stack>
          )}
          <Button
            component={RouterLink}
            to={`/o/${tenantId}/waste/containers?facilityId=${effectiveWasteFacilityId}`}
            variant="text"
            size="small"
            endIcon={<ArrowForward />}
          >
            View containers
          </Button>
        </Stack>
      </DashboardTile.ContentArea>
    </DashboardTile>
  );
};
